<template>
    <div>
        <a-drawer
                :title="title"
                :width="720"
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <!--             <a-spin :spinning="spinning">-->
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
            >
                <a-form-model-item
                        ref="parent_id"
                        label="上级"
                        prop="parent_id"
                        :help="formErr.parent_id"
                        :validateStatus='!formErr.parent_id||formErr.parent_id==[]?"":"error"'
                >
                    <a-cascader :options="formList.adminMenuList" :fieldNames="fieldNames " placeholder="" change-on-select
                                v-model="form.parent_id" :allowClear="false"/>

                </a-form-model-item>
                <a-form-model-item
                        ref="name"
                        label="名称"
                        prop="name"
                        :help="formErr.name"
                        :validateStatus='!formErr.name||formErr.name==""?"":"error"'
                >
                    <a-input
                            v-model="form.name"
                            @change="(e) => { formErr.name=''}"
                            @blur="(e) => {  form.name = e.target.value.trim() }"
                    />
                </a-form-model-item>

                <a-form-model-item
                        ref="app"
                        label="应用名"
                        prop="app"
                        :help="formErr.app"
                        :validateStatus='!formErr.app||formErr.app==""?"":"error"'
                >
                    <a-input
                            v-model="form.app"
                            @change="(e) => { formErr.app=''}"
                            @blur="(e) => {  form.app = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="controller"
                        label="控制器名"
                        prop="controller"
                        :help="formErr.controller"
                        :validateStatus='!formErr.controller||formErr.controller==""?"":"error"'
                >
                    <a-input
                            v-model="form.controller"
                            @change="(e) => { formErr.controller=''}"
                            @blur="(e) => {  form.controller = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="action"
                        label="操作名称"
                        prop="action"
                        :help="formErr.action"
                        :validateStatus='!formErr.action||formErr.action==""?"":"error"'
                >
                    <a-input
                            v-model="form.action"
                            @change="(e) => { formErr.action=''}"
                            @blur="(e) => {  form.action = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="param"
                        label="参数"
                        prop="param"
                        :help="formErr.param"
                        :validateStatus='!formErr.param||formErr.param==""?"":"error"'
                >
                    <a-input
                            v-model="form.param"
                            @change="(e) => { formErr.param=''}"
                            @blur="(e) => {  form.param = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="icon"
                        label="图标"
                        prop="icon"
                        :help="formErr.icon"
                        :validateStatus='!formErr.icon||formErr.icon==""?"":"error"'
                >
                    <a-input
                            v-model="form.icon"
                            @change="(e) => { formErr.icon=''}"
                            @blur="(e) => {  form.icon = e.target.value.trim() }"
                    />
                    <a class="hrefa" href="https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=9402"  target="_blank">选择图片</a><span>加前缀el-icon-b2c </span>

                </a-form-model-item>
                <a-form-model-item
                        ref="icon_hover"
                        label="图标选中"
                        prop="icon_hover"
                        :help="formErr.icon_hover"
                        :validateStatus='!formErr.icon_hover||formErr.icon_hover==""?"":"error"'
                >
                    <a-input
                            v-model="form.icon_hover"
                            @change="(e) => { formErr.icon_hover=''}"
                            @blur="(e) => {  form.icon_hover = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="remark"
                        label="备注"
                        prop="remark"
                        :help="formErr.remark"
                        :validateStatus='!formErr.remark||formErr.remark==""?"":"error"'
                >
                    <a-textarea   :rows="4" v-model="form.remark"
                                  @change="(e) => { formErr.remark=''}"
                                  @blur="(e) => {  form.remark = e.target.value.trim() }"/>
                    <!-- <a-button style="margin-left: 10px;" @click="resetForm">Reset</a-button> -->
                </a-form-model-item>
                <a-form-model-item
                        ref="status"
                        label="状态"
                        prop="status"
                        :help="formErr.status"
                        :validateStatus='!formErr.status||formErr.status==""?"":"error"'
                >
                    <a-select v-model="form.status">
                        <a-select-option :value="item.value" v-for="item in formList.status">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item
                        ref="type"
                        label="类型"
                        prop="type"
                        :help="formErr.type"
                        :validateStatus='!formErr.type||formErr.type==[]?"":"error"'
                >
                    <a-select v-model="form.type">
                        <a-select-option :value="item.value" v-for="item in formList.menuType">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>

            </a-form-model>
            <!--             </a-spin>-->
            <div class="drawer-btn"  >

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">确定</a-button>
                <a-button @click="onClose">取消</a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig} from "../../../utils/utils"
    import API from "../api";

    export default {
        name: "createForm",
        props: ["visible", "formEdit", "title", "ids", "editId" ],
        // props: {
        //     spinning: {
        //         type: Boolean,
        //         default: false
        //     },
        //     formEdit: {},
        //     title:{},
        //     ids:{},
        //     editId:{},
        //
        // },
        data() {
            return {
                drawerConfig,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                fieldNames2: {label: 'name', value: 'value', children: 'children'},
                formList: [],
                formErr: {
                    parent_id: "",
                    name: "",
                    app: "",
                    controller: "",
                    action: "",
                    type: "",
                    status: "",
                    param: "",
                    icon: "",
                    remark: "",
                },
                labelCol: {span: 4}, wrapperCol: {span: 14},
                form: {
                    parent_id:[],
                    name: "",
                    app: "",
                    controller: "",
                    action: "",
                    type:[],
                    status: "",
                    param: "",
                    icon: "",
                    remark: "",
                },
                rules: {
                    parent_id: [{required: true, message: "请输入上级 ", trigger: "blur"}],
                    name: [{required: true, message: "请输入名称 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入名称 "
                    }],
                    app: [{required: true, message: "请输入应用名 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入应用名 ",
                    }],
                    controller: [{required: true, message: "请输入控制器名 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入控制器名 "
                    }],
                    action: [{required: true, message: "请输入操作名 ", trigger: "blur"}, {whitespace: true, message: "请输入操作名 "}],
                    status: [{required: true, message: "请输入菜单状态 ", trigger: "blur"}],
                    type: [{required: true, message: "请输入按钮类型 ", trigger: "blur"}],
                },
                visibles: false
            };
        },
        watch: {
            ids: function (a, b) {
                let parent_id=0
                let parentIndex=0
                let parentIds=[]
              // const findparentIds =(item)=>{   console.log("----",parentIndex)
              //   item.map((items,indexs)=>{
              //     parentIds[parentIndex]=items.id
              //     if(items.children){
              //       if(items.id==item[indexs].id&&items.id==a) {parentIndex=2}
              //       if(items.id==a) {
              //         console.log("----",parentIds)
              //         // parent_id=item.id
              //       }else{
              //         if(indexs==0)parentIndex=parentIndex*1+1
              //         // console.log("----",parentIndex)
              //         findparentIds(items.children)
              //       }  }
              //
              //   })
              // }
                this.formList.adminMenuList.map((item,index)=>{
                  parentIds[0]=item.id
                  parentIndex=0
                    if(item.children){
                      // if(index==0){
                      //   parentIndex=1
                      // }
                      // findparentIds(item.children)
                        item.children.map((items,indexs)=>{
                            if(items.id==a) {
                                parent_id=item.id
                            }
                        })
                    }
                })

                parent_id==0?this.form.parent_id = [a]:this.form.parent_id = [parent_id,a]

            },
            editId: function (a, b) {
                if (a != "") {
                    API.userService.EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        let parentId=val.arrparentid.split(",")
                        if(parentId.length>1) {
                            parentId
                        }else{
                            parentId=[val.parent_id]
                        }
                        val.parent_id =parentId.map(Number)
                        this.form = val

                    })
                } else {
                    this.form.id = ''
                }
            }

        },
        mounted() {
            this.getForm()
        },
        methods: {
            getForm(){
                API.userService.ADD_DATA().then(res => {
                    this.formList = res.data.data
                })
            },
            onClose() {
                this.$emit("changVisible", false);
                this.$refs.ruleForm.resetFields();
                this.formErr={
                    parent_id: "",
                        name: "",
                        app: "",
                        controller: "",
                        action: "",
                        type: "",
                        status: "",
                        param: "",
                        icon: "",
                        remark: "",type:""
                }
                this.getForm()
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let formVal = JSON.parse(JSON.stringify(this.form))
                        formVal.arrparentid=formVal.parent_id.toString()
                        formVal.parent_id = formVal.parent_id[formVal.parent_id.length - 1]
                        let url = ""
                      // console.log("**--**",formVal)
                      // return

                        this.form.id == '' || this.form.id == undefined ? url = API.userService.SUBMIT_ADD : url = API.userService.SUBMIT_EDIT
                        submitForm(url, formVal).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    };
</script>

<style scoped>
    .hrefa{color: #1890ff;display: inline-block;margin-right: 5px}
</style>
